import { schema } from "normalizr";
import { Availability } from "records/item";
import { DeliveryWindowsSchema } from "./delivery-windows";

export const AvailabilitySchema = new schema.Entity(
    "itemAvailabilities",
    {
        delivery_windows: DeliveryWindowsSchema,
    },
    {
        idAttribute: "_id",
    }
);

(AvailabilitySchema as any).record = Availability;
